import apiurl from './apiurl';
const axios = require('axios');

const consultaEstado = async (params, idToken) => {
    try {
        const response = await axios({
            'method': 'GET',
            'url': apiurl + 'consultaestadodoc',
            'headers': {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            'crossdomain': true,
            'params': {
                ...params
            }
        })
        return response.data
    } catch (error) {
        throw error;
    }

}
export default consultaEstado;